import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-sell-category-list',
	templateUrl: './sell-category-list.component.html',
	styleUrls: ['./sell-category-list.component.css'],
})
export class SellCategoryListComponent extends ListComponent {
	protected apiUrl = 'sell_category';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'use', name: 'Licz od całości' },
		{ id: 'fee', name: 'Prowizja (wartość %)' },
	];

	protected convertData(data) {
		data.results.map((item) => {
			item.use = item.use ? 'tak' : 'nie';
		});
		return data.results;
	}

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/5/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
